/**
 * What a property is charged for the account setup fee.
 *
 * A property may set its own amount, but never above the customer's price, and a property that has
 * set none is charged the price. Both halves matter: a stored amount can outlive a price that has
 * since come down, so the cap is applied on the way out and not only on the way in.
 *
 * @param propertyAmount the property's own amount, or null/undefined when it has set none.
 * @param price the customer's price for this property.
 */
export const accountSetupFeeAmount = (propertyAmount, price) => Math.min(propertyAmount !== null && propertyAmount !== void 0 ? propertyAmount : price, price);